<!--<div class="row">
    <div class="col-lg-12 text-center">
        <h2>{{selectedCustomerId > 0 ? 'Edit' : 'Add'}} Customer</h2>
    </div>
</div>-->
<epi-container [header]="'Customer'">
    <form [formGroup]="customerForm">
        <div class="row">
            <div class="col-lg-6">
                <div class="form-group">
                    <label><strong>Name</strong></label>
                    <input class="form-control input-sm" type="text" formControlName="nameCtrl" />
                    <mat-error *ngIf="submitted && customerForm.controls['nameCtrl'].hasError('required')">Please enter a name</mat-error>
                </div>
                <div class="form-group">
                    <label><strong>Address:</strong></label>
                    <input class="form-control input-sm" type="text" formControlName="addressOneCtrl" maxlength="100" />
                    <mat-error *ngIf="submitted && customerForm.controls['addressOneCtrl'].hasError('required')">Please enter an address</mat-error>
                </div>
                <div class="form-group">
                    <label><strong>Address 2:</strong></label>
                    <input class="form-control input-sm" type="text" formControlName="addressTwoCtrl" maxlength="100" />
                </div>
                <div class="form-group">
                    <label><strong>City:</strong></label>
                    <city-dropdown [parentForm]="customerForm" [ctrlName]="'cityCtrl'" [placeholder]="'Select a City'" [cityId]="selectedCustomer.cityId" [isRequired]="true"></city-dropdown>
                </div>
                <div class="form-group">
                    <label><strong>Zip:</strong></label>
                    <input class="form-control input-sm" type="text" formControlName="zipCtrl" (focusout)="leaveZip()" />
                </div>
                <div class="form-group" *ngIf="selectedCustomerId > 0">
                    <label><strong>Status: {{customerStatus}}</strong></label>
                    <div *ngIf="isStatusEdit(customerStatus)">
                        <div *showRolesIf="'CRM Admin'">
                            <mat-select placeholder="" class="form-control" formControlName="statusCtrl">
                                <mat-option>--</mat-option>
                                <mat-option *ngFor="let customerStatus of customerStatusList" [value]="customerStatus.customerStatusId">
                                    {{customerStatus.abbreviation}}
                                </mat-option>
                            </mat-select>
                        </div>
                    </div>
                </div>
                <div class="form-group" *ngIf="selectedCustomerId <= 0">
                    <label><strong>Status</strong></label>
                    <mat-select placeholder="" class="form-control" formControlName="statusCtrl" [(value)]="customerStatusId">
                        <mat-option>--</mat-option>
                        <mat-option *ngFor="let customerStatus of customerStatusList" [value]="customerStatus.customerStatusId">
                            {{customerStatus.abbreviation}}
                        </mat-option>
                    </mat-select>
                </div>
                <div class="form-group">
                    <mat-checkbox formControlName="billToIndCtrl">Bill To</mat-checkbox>
                    <mat-checkbox formControlName="shipperIndCtrl">Shipper</mat-checkbox>
                    <mat-checkbox formControlName="consigneeIndCtrl">Consignee</mat-checkbox>
                </div>
                <div class="form-group">
                    <mat-checkbox formControlName="activeIndCtrl">Active</mat-checkbox>
                </div>
                <div class="form-group">
                    <mat-checkbox formControlName="retiredIndCtrl">Retired</mat-checkbox>
                </div>
                <div class="form-group">
                    <label><strong>Freight Spend</strong></label>
                    <kendo-numerictextbox [min]="0" formControlName="freightCtrl"></kendo-numerictextbox>
                </div>
                <div class="form-group">
                    <label><strong>Credit Limit</strong></label>
                    <kendo-numerictextbox [min]="0" formControlName="creditLimitAmountCtrl" [disabled]="!isCRMAdmin"></kendo-numerictextbox>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="form-group">
                    <label><strong>Sales Rep</strong></label>
                    <mat-select class="form-control" placeholder="" formControlName="salesRepCtrl" [disabled]="hasSales()">
                        <mat-option>--</mat-option>
                        <mat-option *ngFor="let employee of salesReps" [value]="employee.employeeId">
                            {{employee.fullName}}
                        </mat-option>
                    </mat-select>
                </div>
                <div class="form-group">
                    <label><strong>Ops Rep</strong></label>
                    <mat-select class="form-control" placeholder="" formControlName="opsRepCtrl" [disabled]="hasSales()">
                        <mat-option>--</mat-option>
                        <mat-option *ngFor="let employee of opsReps" [value]="employee.employeeId">
                            {{employee.fullName}}
                        </mat-option>
                    </mat-select>
                </div>
                <div class="form-group">
                    <label><strong>Account Rep</strong></label>
                    <mat-select class="form-control" placeholder="" formControlName="accountRepCtrl" [disabled]="hasSales()">
                        <mat-option>--</mat-option>
                        <mat-option *ngFor="let employee of accountReps" [value]="employee.employeeId">
                            {{employee.fullName}}
                        </mat-option>
                    </mat-select>
                </div>
                <div class="form-group">
                    <label><strong>Contact Name</strong></label>
                    <input class="form-control input-sm" type="text" formControlName="contactNameCtrl" />
                    <mat-error *ngIf="submitted && customerForm.controls['contactNameCtrl'].hasError('required')">Enter a contact</mat-error>
                </div>
                <div class="form-group">
                    <label><strong>Phone</strong></label>
                    <kendo-maskedtextbox [mask]="phoneMask" class="form-control input-sm" type="text" formControlName="contactPhoneCtrl"></kendo-maskedtextbox>
                    <mat-error *ngIf="submitted && customerForm.controls['contactPhoneCtrl'].invalid">Enter valid phone #</mat-error>
                </div>
                <div class="form-group">
                    <label><strong>Email</strong></label>
                    <input class="form-control input-sm" type="text" formControlName="contactEmailCtrl" />
                </div>
                <div class="form-group">
                    <label><strong>Initiatives</strong></label>
                    <kendo-multiselect formControlName="initiativesCtrl"
                                        [data]="initiatives"
                                        [textField]="'title'"
                                        [valuePrimitive]="true"
                                        [valueField]="'customerInitiativeID'"
                                        [popupSettings]="{ appendTo: 'component' }">
                    </kendo-multiselect>
                </div>
                <div class="form-group">
                    <mat-checkbox formControlName="isParentCtrl">Is Parent</mat-checkbox>
                </div>
                <div class="form-group">
                    <label><strong>Monthly Revenue Base Line</strong></label>
                    <kendo-numerictextbox [min]="0" formControlName="revenueBaseLineCtrl"></kendo-numerictextbox>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-7">
                <div class="form-group">
                    <label><strong>CRM Notes</strong></label>
                    <textarea rows="5" class="form-control" formControlName="crmNotesCtrl" [(ngModel)]="crmNotes.commentText" (focusout)="saveComment(crmNotes, 'crmNotes')"></textarea>
                </div>
                <div class="form-group">
                    <label><strong>Operational Notes</strong></label>
                    <textarea rows="5" class="form-control" formControlName="operationalNotesCtrl" [(ngModel)]="operationalNotes.commentText" (focusout)="saveComment(operationalNotes, 'operationalNotes')"></textarea>
                </div>
            </div>
            <div class="col-lg-5 text-end">
                <button class="btn btn-primary m-2" (click)="saveCustomer(false)" [disabled]="(isSavingCustomer || isSavingContact)">Save</button>
                <button class="btn btn-primary m-2" (click)="saveCustomer(true)" [disabled]="(isSavingCustomer || isSavingContact)">Save and Sync ERP</button>
                <br />
                <p class="float-right">
                    {{saveMessage}}
                </p>
            </div>
        </div>
    </form>
</epi-container>

<div class="spinner_container dark-overlay" [ngClass]="{'dark-overlay': (isSavingCustomer || isSavingContact)}">
    <mat-spinner style="left: 50%; top: 50%" *ngIf="(isSavingCustomer || isSavingContact)"></mat-spinner>
</div>
